var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getDefaultStore } from '../../store';
import { getDefaultCacheModel } from '../defaults';
export function getResourceService(resource, options) {
    if (options === void 0) { options = {}; }
    if (typeof options === 'string' || typeof options === 'number') {
        options = { vars: options };
    }
    var cacheModelOption = options.cacheModel, storeOption = options.store, context = options.context, requestOptions = __rest(options, ["cacheModel", "store", "context"]);
    var cacheModel = cacheModelOption || getDefaultCacheModel();
    var store = storeOption || getDefaultStore();
    var cache = cacheModel({ store: store, context: context });
    return cache.request(resource, requestOptions);
}
//# sourceMappingURL=getResourceService.js.map